module.exports = __webpack_public_path__ + "img/liumengyuan.94b4e5f5.jpg";